import styled, { css } from 'styled-components';
/**
 * Navigation link label container
 */
export const navigationLinkLabelContainerStyles = () => css `
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
`;
export const NavigationLinkLabelContainer = styled.span `
	${navigationLinkLabelContainerStyles}
`;
